import { Exercises } from "app-interfaces";

import CatalogClass from "../../../models/Catalog";
import { ExerciseTypesEnum } from "../../../types/StaticTypes";
import { FilterTabs, FilterValue } from "./ExerciseFilter";

const filterExercises = (catalog: CatalogClass, filterValue: FilterValue) => {
  const searchQueryPredicate = (exercise: Exercises.IExercise) =>
    exercise.name.toLowerCase().includes(filterValue.searchQuery.toLowerCase());

  const exerciseTypePredicate = (exercise: Exercises.IExercise) =>
    exercise.type === ExerciseTypesEnum[filterValue.exerciseType!];

  let filteredExercises =
    filterValue.tab === FilterTabs.MY_EXERCISES ? catalog.MyExercises : catalog.Exercises;

  if (filterValue.exerciseType !== null) {
    filteredExercises = filteredExercises.filter(exerciseTypePredicate);
  }

  if (filterValue.searchQuery !== "") {
    filteredExercises = filteredExercises.filter(searchQueryPredicate);
  }

  return filteredExercises;
};

export default filterExercises;
